import { getColorTokenName } from '../get-color-token-name/get-color-token-name';

export const isColorPalette = (color: string) => {
  const tokenConfig = getColorTokenName(color);
  return !(!tokenConfig.variable || color?.startsWith('--'));
};
